import vSelect from "vue-select";

export default {
	props: {
		context: {
			type: Object,
			required: true
		},
		labelFormatter: {
			type: Function,
			default: (option) => option.label
		}
	},

	components: {
		"v-select": vSelect,
	},

	mounted() {

	},

	data() {
		return {
		};
	},

	computed: {
		selectClasses() {
			return [
				'formulate-input-element',
				`formulate-input-element--${this.context.type}`,
				{ 'formulate-input-element--empty': !this.optionIsAvailable(this.context.model) },
			];
		},
		selectedValue: {
			get() {
				return this.optionIsAvailable(this.context.model) ? this.context.model : null;
			},
			set(value) {
				this.context.model = value;
			},
		},
	},

	methods: {
		optionIsAvailable(value) {
			if (value === null || value === undefined || value === '') {
				return false;
			}

			const options = Array.isArray(this.context.options) ? this.context.options : [];
			return options.some((option) => {
				if (option && typeof option === 'object') {
					return option.value === value || option.uuid === value || option.id === value;
				}
				return option === value;
			});
		},
		onOptionSelect() {
			this.$emit('selected');
		},
		onClose: function () {
			this.context.blurHandler();
		},
	},
};
